import React, {useEffect, useState} from 'react'
import './Guida.css'
import {NavLink} from 'react-router-dom'
import Intro_Image from "./Img/Intro-image.png"
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dracula  } from 'react-syntax-highlighter/dist/esm/styles/prism';
import ReactHtmlParser from 'react-html-parser';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboard, faClipboardCheck } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';

const Guida = () => {
    const url = "https://raw.githubusercontent.com/MattiaBracco05/WidgetTkinter/main/widget.json"
    let nome_filtro = localStorage.getItem('nome');
    const [data, setData] = useState([]);
    const [cpyIcon, setCpyIcon] = useState(faClipboard);
    
    useEffect(() => {
        let title = document.getElementsByTagName('title')[0]
        title.innerHTML = `Progetto 4C | ${nome_filtro}`
        window.scrollTo(0,0)

        fetch(url)
        .then(response => response.json())
        .then(data => setData(data))
    }, [])

    const renderGuida = () => {

        return data.map((elem, i) => {
          if (elem.parte[0].titolo === nome_filtro) {
            return (
                <React.Fragment key={i}>
                    <h1 className="tit d-flex justify-content-center mb-4 mt-4" data-aos="flip-right">
                        {elem.parte[0].titolo}
                    </h1>

                    <div className="contenitore-testo">
                        <pre className="testo" data-aos="flip-down">{ReactHtmlParser(elem.parte[0].corpo)}</pre>
                    </div>
        
                    {elem.parte[0].code.map((code, index) => (
                    <div className='code-container' data-aos="zoom-in-down" key={index}>
                        <FontAwesomeIcon icon={cpyIcon} onClick={(e)=>copiaTesto(e)} className='cpy'/>
                        <SyntaxHighlighter language="python" style={dracula} key={index} className="mt-4 code-ex">
                            {code}
                        </SyntaxHighlighter>
                    </div>
                    ))}

        
                    <div className="row d-flex justify-content-center" data-aos="flip-down">
                    {elem.parte[0].prestetazione !== "" && (
                        <a
                        className="button-pre col-xl-5 col-lg-5 col-md-5 col-sm-5 col-11 mt-3 mr-xl-3 mr-lg-3 mr-md-3 mr-sm-3 d-flex justify-content-center aling-items-center"
                        href={elem.parte[0].prestetazione}
                        target="_blank"
                        style={{ textDecoration: 'none' }}
                        >
                        <strong>Visualizza presentazione</strong>
                        </a>
                    )}
        
                    {elem.parte[0].pdf !== "" && (
                        <a
                        className="button-pdf col-xl-5 col-lg-5 col-md-5 col-sm-5 col-11 mt-3 mr-xl-3 mr-lg-3 mr-md-3 mr-sm-3 d-flex justify-content-center aling-items-center"
                        href={elem.parte[0].pdf}
                        target="_blank"
                        style={{ textDecoration: 'none' }}
                        >
                        <strong>Visualizza pdf</strong>
                        </a>
                    )}
                    </div>
                </React.Fragment>
                )
            } else {
                return null
            }
        })
    }

    const Toast = Swal.mixin({
        toast: true,
        position: 'top',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.addEventListener('mouseenter', Swal.stopTimer)
          toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })
      

    const copiaTesto = async (e) => {
        e.stopPropagation()

        try {
            const text = e.currentTarget.nextSibling.innerText;
            await navigator.clipboard.writeText(text)
            Toast.fire({
                icon: 'success',
                title: 'Testo copiato con successo!'
            })
            setCpyIcon(faClipboardCheck)
        } catch (err) {
            console.error('Failed to copy: ', err)
        }

        setTimeout(() => setCpyIcon(faClipboard), 3000);
    }
      

    const scrollToTop =()=> {
        const topElement = document.documentElement;
        topElement.scrollIntoView({
            behavior: 'smooth'
        })
    }

  return (
    <div>
        {/* === sotto nav bar === */}
        <div className='row under-nav d-flex justify-content-center align-items-center mt-5'>
            <div className="col-xl-4 col-lg-4 col-md-7 col-sm-10 col-11 d-flex justify-content-center align-items-center order-lg-1 order-xl-1 order-2 pt-lg-0 pt-xl-0 pt-4" data-aos="fade-up" data-aos-delay="400">
                <div>
                    <h1 className='sub-under-nav'>| Home<br/> Benvenuto nella home dei progetti della 4C ITIS INFO</h1>
                    <p className='txt-under-nav mt-3'>
                        In questa pagina troverai tutti gli studenti della classe che hanno contribuito ad alemno un progetto
                    </p>

                    <div className='d-flex justify-content-lg-start justify-content-xl-start justify-content-md-center justify-content-sm-center justify-content-center mb-3'>
                        <NavLink className='btn-esplora col-6' style={{textDecoration:"none", color:"white"}} to={"/Progetti/Tkinter"}> <strong>Torna all'indice</strong> </NavLink>
                    </div>
                </div>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-9 col-10 mt-5 d-flex justify-content-center order-1 order-lg-2 order-xl-2 mt-5" data-aos="zoom-in" data-aos-delay="400">
                <img src={Intro_Image} alt="" className='img-fluid flaoting res-intro-image'/>
            </div>
        </div>

        <svg width="100%" height="100%" id="svg" viewBox="0 0 1440 310" xmlns="http://www.w3.org/2000/svg" className="mw transition duration-300 ease-in-out delay-150">
            <path d="M 0,400 C 0,400 0,200 0,200 C 198.13333333333333,154.66666666666669 396.26666666666665,109.33333333333334 529,128 C 661.7333333333333,146.66666666666666 729.0666666666667,229.33333333333331 870,252 C 1010.9333333333333,274.6666666666667 1225.4666666666667,237.33333333333334 1440,200 C 1440,200 1440,400 1440,400 Z" stroke="none" strokeWidth="0" fill="#0104a3" fillOpacity="1" className="transition-all duration-300 ease-in-out delay-150 path-0" transform="rotate(-180 720 200)"></path>
        </svg>
        {/* === sotto nav bar === */}


        <div className='container mt-5' id="guida-container">
            <div className="box-spiegazioni">
                {renderGuida()}
            </div>
        </div>


        {/* INIZIO BOTTONE SCROLLA SU */}
        <button id="scrollToTopBtn" onClick={scrollToTop}>&#8593;</button>
        {/* FINE BOTTONE SCROLLA SU */}

    </div>
    
  )
}

export default Guida